import { Component, inject } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { UserService } from '../../../../services/user.service';
import { AsyncPipe } from '@angular/common';
import { HasPermissionDirective } from '../../../../security/has-permission.directive';
import { USER_PERMISSIONS } from '../../../../constants/permissions';

/** Navigation sidebar for the counselor view. Fetches and exposes the current user for display. */
@Component({
  selector: 'app-district-nav',
  imports: [MatIconModule, MatListModule, RouterModule, AsyncPipe, HasPermissionDirective],
  templateUrl: './district-nav.html',
  styleUrl: './district-nav.css',
})
export class DistrictNav {
  constructor() {}

  /** Tracks the currently active nav item for highlight state in the template. */
  activeElement = 'dashboard';

  /** Permission constants exposed to the template. */
  permissions = USER_PERMISSIONS;

  /** Service for fetching the current authenticated user. */
  private userService = inject(UserService);

  /** Observable of the current user, bound directly in the template via async pipe. */
  user$ = this.userService.getCurrentUser();

  ngOnInit(): void {}
}
